import { observer } from 'mobx-react'
import { cx } from '@/utils/cx'
import { useContext, useEffect, useState } from 'react'
import { Button, DocumentCheckbox } from '@/components/Generic'
import PrivacyPolicy from '@/assets/privacy_policy.pdf'
import PrivacyPolicyDe from '@/assets/privacy_policy_de.pdf'
import tink from '@/assets/tink_logo.png'
import { StoreContext } from '@store/Root.store'
import { CheckedEvent } from '@/types/generic'

export const MicropaymentInfoAmexPage = observer(() => {
  const [consent, setConsent] = useState(false)

  const store = useContext(StoreContext)
  const { isMobile } = store.AppState
  const { language } = store.TranslationsState

  const {
    klarnaPrivacyPolicyPage: policyPage,
    micropaymentInfoPage: trans,
    generalConditionsPage: generalConditionsTrans,
  } = store.TranslationsState.translationsNew

  const handleProceed = async () => {
    store.ScenarioState.nextPage()
  }

  const handleConsent = ({ checked: value }: CheckedEvent) => {
    setConsent(value)
  }

  return (
    <div className={cx('page-container', 'mobile-m-0', 'mobile-p-14-40', 'w-500', 'p-40')}>
      <div className="amex__micropayment__title">Account information</div>

      {trans.content.split('\n').map((item, i) => (
        <div className="amex__micropayment__info" key={i}>
          {item}
        </div>
      ))}

      <div className="amex__micropayment__separator" />

      <div className="ikano__tink-info">
        <div className="ikano__center-liner">
          <img src={tink} alt="tink logo" />
        </div>
        <div className="amex__micropayment__info">{trans.tink}</div>
      </div>

      <DocumentCheckbox
        inputName="terms-checkbox"
        description={policyPage.consent}
        externalUrl={language === 'de' ? PrivacyPolicyDe : PrivacyPolicy}
        handleDecision={handleConsent}
        value={consent}
        goToDocumentLabel={generalConditionsTrans.goToDocument}
      />

      <div className="layout__content-container-bottom-fixed">
        {!isMobile ? <div className="layout__content-container-bottom-left" /> : <div />}
        <Button onClick={() => handleProceed()} disabled={!consent}>
          <span className="generic__button-text">{trans.proceed}</span>
        </Button>
      </div>

      <div className="layout__mobile-spacer-for-content-container-bottom-fixed" />
    </div>
  )
})
